import React, { useState, useEffect } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Card, CardBody, Col, Row, Table } from 'reactstrap';
import Select from 'react-select';
import { sortByOptionsForSearchTracker } from '../../helper';

const SearchPositionTrackerTable = ({ reactTableData, data, customClass }) => {
   
  const [rowData, setData] = useState([]);
  // const [headerData, setHeaderData] = useState([]);
  const [isSortable, setIsSortable] = useState(false);
  const [isResizable, setIsResizable] = useState(true);
  const [withPagination, setWithPaginationTable] = useState(true);
  const [withSearchEngine, setWithSearchEngine] = useState(true);
  const [sortBySelected, setSortBySelected] = useState(sortByOptionsForSearchTracker[0])

  useEffect(() => {
    setData(data || []);
}, [data]);

  const currentDataByKeyword = {};
  const allDataData = {};
  let dataToPlot = [];

  rowData.forEach((item) => {
    if (item && currentDataByKeyword[item?.keyword]) {
        currentDataByKeyword[item?.keyword]?.push(item)
    } else if (item) {
        if (!item?.keyword || item?.keyword === 'null') {
            currentDataByKeyword?.['N/A']?.push(item)
        } else {
            currentDataByKeyword[item?.keyword] = [item]
        }
    }

    if (item && allDataData[item?.reportDate]) {
        allDataData[item?.reportDate]?.push(item)
    } else if (item) {
        if (!item?.reportDate || item?.reportDate === 'null') {
            allDataData?.['N/A']?.push(item)
        } else {
            allDataData[item?.reportDate] = [item]
        }
    }
  })

  const currentKeyword = Object.keys(currentDataByKeyword);
  const dates = Object.keys(allDataData);
  
  const headerData = [{
    Header: 'Keyword',
    accessor: 'keyword',
    disableGlobalFilter: false,
  },
  {
    Header: 'Search Volume',
    accessor: 'searchVolume',
    disableGlobalFilter: false,
  },
  {
    Header: 'Keyword Sales',
    accessor: 'keywordSales',
    disableGlobalFilter: false,
  },
  {
    Header: 'Type',
    accessor: 'type',
    disableGlobalFilter: false,
  }];

  for (let index = 0; index < dates.length; index += 1) {
    const date = dates[index];
    headerData.push({
        Header: date.toString(),
        accessor: date.toString(),
        disableGlobalFilter: false,
        // rightAlign: true,
        width: 100, 
        // sortType       
    })
    // console.log(element)
  }
 
  const reduceCallback = (acc, currentRow) => {   
    if (acc[currentRow.reportDate]) {
      acc?.[currentRow.reportDate]?.push(currentRow)
    } else {
      acc[currentRow.reportDate] = [currentRow]
    }    
    return acc
  }

  for (let index = 0; index < currentKeyword.length; index += 1) {
    const kWord = currentKeyword[index];
    const currentKeywordData = currentDataByKeyword?.[kWord] ?? [];    

    const searchVolumeSum = currentKeywordData.reduce((accum, item) => Number(Number(Number(accum) +
    (item.searchVolume === '-' ? 0  : Number(item.searchVolume)))), 0) ?? 0;
    const keywordSalesSum = currentKeywordData.reduce((accum, item) => Number(Number(Number(accum) +
    (item.keywordSales === '-' ? 0  : Number(item.keywordSales)))), 0) ?? 0;

    const dateWiseData = currentKeywordData?.reduce(reduceCallback, {})
    const dateWiseFinalData = Object.keys(dateWiseData).reduce((acc, currentDate) => {
        acc[currentDate] = {
            currentData: dateWiseData[currentDate]
        }
        return acc
    }, {})
    
    dataToPlot.push({
        keyword: kWord,
        searchVolume: searchVolumeSum.toString(),
        keywordSales: keywordSalesSum.toString(),
        type: {
            organicType: 'organic',
            sponsoredPosition: 'Sponsored'
        },
        dateWiseFinalData
    })
  }
  
  const updateEditableData = (rowIndex, columnId, value) => {
    setData(old => old.map((item, index) => {
      if (index === rowIndex) {
        return {
          ...old[rowIndex],
          [columnId]: value,
        };
      }
      return item;
    }));
  };

  const handleClickIsSortable = () => {
    setIsSortable(!isSortable);
  };

  const handleClickWithPagination = () => {
    setWithPaginationTable(!withPagination);
  };

  const handleClickIsResizable = () => {
    setIsResizable(!isResizable);
  };

  const handleClickWithSearchEngine = () => {
    setWithSearchEngine(!withSearchEngine);
  };

  const tableConfig = {
    isEditable: false,
    isResizable: true,
    isSortable: true,
    withPagination,
    withSearchEngine,
    manualPageSize: [250, 500, 1000, 1500, 2000],
    placeholder: 'Search by Title...',
  };


  const handleBackgroundColor = (numericValue) => {
    let backgroundColor = 'white';
    // const numericValue = parseInt(value, 10);    
    if(numericValue > 0 && numericValue <= 10){
      backgroundColor = 'green';
    }
    else if (numericValue > 10 && numericValue <= 50){
      backgroundColor = 'yellowgreen';
    }
    else if (numericValue > 50 && numericValue <= 100){
      backgroundColor = 'yellow';
    }
    else if (numericValue > 100 && numericValue <= 150){
      backgroundColor = '#ffae42';
    }
    else if (numericValue > 150 && numericValue <= 200){
      backgroundColor = 'orange';
    }
    else if (numericValue > 200 && numericValue <= 250){
      backgroundColor = 'redorange';
    }
    else if (numericValue > 250) {
      backgroundColor = 'red';
    }
    return backgroundColor;
  }

  

  const sortBy = sortBySelected?.value;
  if (sortBy === 'searchVolume') {    
    dataToPlot = dataToPlot?.sort((a, b) =>
    parseInt(b?.[sortBy], 10) - parseInt(a?.[sortBy], 10))
  } else if (sortBy === 'keywordSales') {
    dataToPlot = dataToPlot?.sort((a, b) =>
    parseInt(b?.[sortBy], 10) - parseInt(a?.[sortBy], 10))
  }
  else if (sortBy === 'keyword') {
    dataToPlot = dataToPlot?.sort((a, b) =>
      a?.[sortBy]?.toLowerCase().localeCompare(b?.[sortBy]?.toLowerCase()))
  }

  return (
    // <Col md={12} lg={12}>
      <Card>
        <CardBody className={`${customClass} pl-0 pr-0`}>
          <div>
          {/* <div className="form__form-group mb-3 col-md-12" id='dvTable'> */}
            {/* <Row>
            <Col md="11" className='pr-0'>
            <div className="form__form-group mb-0">
              <span className="form__form-group-label">Filter</span>
              <div className="form__form-group-field">
                    <Select
                      value={sortBySelected}
                      options={sortByOptionsForSearchTracker}
                      clearable={false}
                      placeholder='Select one'
                      className="sku-select_filter-250"
                      onChange={event => setSortBySelected(event)}
                      classNamePrefix="react-select"                      
                    />
                  </div>
            </div>
          </Col>
            </Row> */}
              <div 
                className="row justify-content-center align-items-center mb-3"
                id="dvFilter"
                 >
               <div className="col-12" >
                  <span className="form__form-group-label font-weight-bold">
                    Sort By</span>
                  <div className="form__form-group-field">
                    <Select
                      value={sortBySelected}
                      options={sortByOptionsForSearchTracker}
                      clearable={false}
                      placeholder='Select one'
                      className="search-select_filter-200"
                      onChange={event => setSortBySelected(event)}
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
              </div>
            {/* </div> */}
            <div style={{overflowY: 'auto', maxHeight: '400px'}}>
              <Table responsive striped hover className="dashboard__table-orders" 
                width="100%" >
                  {/* <thead style={{ position: 'sticky', top: '0', zIndex: '1', background: 'white'}}> */}
                  <thead>
                      <tr>
                          {headerData.map((item,index) => {
                            const thStyle = { minWidth: '250px' };
                            if (item?.Header === 'keyword') {
                                thStyle.minWidth = '120px';
                                thStyle.textAlign = 'left';                                
                                thStyle.position = 'sticky';
                                thStyle.left = '0';
                                thStyle.zIndex = '2';   
                                thStyle.backgroundColor = 'white';
                            } else if (item?.Header === 'searchVolume') {
                                thStyle.minWidth = '100px';
                                thStyle.textAlign = 'right';
                                thStyle.position = 'sticky';
                                thStyle.left = '100px';
                                thStyle.zIndex = '2';   
                                thStyle.backgroundColor = 'white';
                            } else if (item?.Header === 'keywordSales') {
                                thStyle.minWidth = '100px';
                                thStyle.textAlign = 'right';
                                thStyle.position = 'sticky';
                                thStyle.left = '200px';
                                thStyle.zIndex = '2';  
                                thStyle.backgroundColor = 'white'; 
                            } else if (item?.Header === 'type') {
                                thStyle.minWidth = '100px';
                                thStyle.textAlign = 'center';
                                thStyle.position = 'sticky';
                                thStyle.left = '300px';
                                thStyle.zIndex = '2';   
                                thStyle.backgroundColor = 'white';
                            } 
                            else {
                                thStyle.minWidth = '30px';
                                thStyle.textAlign = 'center';
                                thStyle.marginRight = '20px';
                                
                            }
                            //  style={{ position: 'sticky', left: 0, zIndex: 1, background: 'white' }}
                            return (
                              <td style={{thStyle}}>
                                {index > 3 ? 
                                  moment(item?.Header).format('MM/DD').trim()
                                  : item?.Header}
                              </td>
                            );
                              
                          })}
                      </tr>
                  </thead>
                  <tbody>
                      {dataToPlot?.length ? dataToPlot?.map(item => (
                          <tr key={item.keyword}>
                              <td 
                                  style={{                                     
                                      minWidth: '120px',
                                      textAlign: 'left',
                                      // verticalAlign: 'middle',
                                      position: 'sticky',
                                      left: '0',
                                      zIndex: '2',
                                      backgroundColor: 'white'
                                  }} 
                                  // rowSpan={2}
                              >
                                  {item.keyword}
                              </td>
                              <td 
                                  style={{                                    
                                      minWidth: '100px',
                                      textAlign: 'center',
                                      // verticalAlign: 'middle',
                                      position: 'sticky',
                                      left: '100px',
                                      zIndex: '2',
                                      backgroundColor: 'white'
                                    }} 
                                  // rowSpan={2}
                              >
                                  {item.searchVolume}
                              </td>
                              <td 
                                  style={{                                      
                                      minWidth: '100px',
                                      textAlign: 'center',
                                      // verticalAlign: 'middle',
                                      position: 'sticky',
                                      left: '200px',
                                      zIndex: '2',
                                      backgroundColor: 'white'
                                  }} 
                                
                                  // rowSpan={2}
                              >
                                  {item.keywordSales}
                              </td>                            
                              <td style={{                                
                                  minWidth: '100px',
                                  position: 'sticky',
                                  // textAlign: 'left',
                                  left: '300px',
                                  zIndex: '2', 
                                  backgroundColor: 'white'
                                }}
                              >
                                  <tr>
                                    <td>
                                    {item?.type?.organicType}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                    {item?.type?.sponsoredPosition}
                                    </td>
                                  </tr>
                                      {/* <span>{item?.type?.organicType}</span><br/>
                                      <span>{item?.type?.sponsoredPosition}</span> */}
                                  
                              </td>
                              {headerData.map((header, index) => (
                                  index > 3 ? (
                                      <td
                                        key={header?.Header}
                                        style={{ 
                                          // paddingTop: '4px', 
                                          // paddingBottom: '4px' ,  
                                          paddingLeft: '14px',                                        
                                          minWidth: '30px',
                                          textAlign: 'center'
                                        }}
                                      //   key={index} // Add a unique key for React
                                      >
                                        <tr>
                                          <td
                                            style={{
                                              backgroundColor:
                                              handleBackgroundColor(item?.dateWiseFinalData?.
                                                [header?.Header]?.
                                                currentData[0]?.organicRank),
                                              color: 
                                                item?.dateWiseFinalData?.
                                                [header?.Header]?.currentData[0]
                                                ?.sponsoredPosition
                                                === '-' ? 'black' : 'black',  
                                              minWidth: '10%'                                          
                                            }}
                                          >
                                          {item?.dateWiseFinalData?.[header?.Header]?.currentData[0]?.organicRank}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            style={{
                                              backgroundColor: 
                                              handleBackgroundColor(item?.dateWiseFinalData?.
                                                [header?.Header]?.
                                                currentData[0]?.sponsoredPosition),
                                              color: 
                                              item?.dateWiseFinalData?.[header?.Header]
                                              ?.currentData[0]?.sponsoredPosition
                                              === '-' ? 'black' : 'black' ,
                                              minWidth: '10px'                                  
                                            }}
                                          >
                                          {item?.dateWiseFinalData?.[header?.Header]?.currentData[0]?.sponsoredPosition}
                                          </td>
                                        </tr>                                    
                                      </td>
                                    ) : null
                              ))}
                          </tr>
                      )) : 'No data to display'}
                  </tbody>
              </Table>
            </div>
          </div>         
        </CardBody>
      </Card>
    // </Col>
  );
};

SearchPositionTrackerTable.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  customClass: PropTypes.string,
};

SearchPositionTrackerTable.defaultProps = {
  customClass: ''
}

export default SearchPositionTrackerTable;
